 
import axios from 'axios';
import Text from  '../common/Text'
import LoginPage from "../common/LoginPage";
import { useNavigate } from 'react-router-dom'; // useNavigate 훅을 사용
import React, {useState,useEffect} from 'react';

function Login() {

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate(); // useNavigate 훅을 사용하여 navigate 함수 가져오기
    useEffect(() => {

        if(!isLoggedIn)
        {


            axios.post('/sessionCheck')
            .then((res) => {
               
                if(res.data=='인증완료')
                    {
                        setIsLoggedIn(true);
                    }
                else
                    {
                        setIsLoggedIn(false);
                    }
            })
             
        }
         

       
    }, [isLoggedIn]);

    const handleLogout = () => {

        axios.post('/Logout')
        .then((res) => {
               
            setIsLoggedIn(false); // 로그인 상태 업데이트
            navigate('/'); // 화면 전환
            window.location.reload(); // 페이지 새로고침
        })
         
    };
 
    return (
        <div>

                    {isLoggedIn ? (
                        <div>
                        <h5>
                            이미 로그인 되어 있습니다.
                        </h5>
                        <button type="button" 
                        style={{
                            padding: '10px', backgroundColor: '#007bff',color:'white',border:'none',borderRadius:'4px', fontSize:'16px',cursor:'pointer'
                        }}
                        onClick={handleLogout}>로그아웃</button>
                        </div>
                    ) : (
                        <div style={{display:'grid', placeItems:'center' }}>
                
                            <LoginPage/>
                            
                        </div>
                    )}
            
            
         
            
        </div>
    );
}

export default Login;